let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ffApz")).then(() => parcelRequire('2PPHJ'));